import { TypedTypePolicies } from './graphql/generated/apollo-helpers'

const typePolicies: TypedTypePolicies = {
  Query: {
    fields: {
      car: {
        merge(_existing, _incoming) {
          return _incoming
        },
      },
      report: {
        merge(_existing, _incoming) {
          return _incoming
        },
      },
      proposal: {
        merge(_existing, _incoming) {
          return _incoming
        },
      },
      deal: {
        merge(_existing, _incoming) {
          return _incoming
        },
      },
      invoice: {
        merge(_existing, _incoming) {
          return _incoming
        },
      },
      driver: {
        merge(_existing, _incoming) {
          return _incoming
        },
      },
      customer: {
        merge(_existing, _incoming) {
          return _incoming
        },
      },
    },
  },
  CarNode: {
    merge: true,
    keyFields: ['id'],
  },
  DealNode: {
    merge: true,
    keyFields: ['id'],
  },
  ReportNode: {
    merge: true,
    keyFields: ['id'],
  },
  CustomerNode: {
    merge: true,
    keyFields: ['id'],
  },
  ProposalNode: {
    merge: true,
    keyFields: ['id'],
  },
  DriverNode: {
    merge: true,
    keyFields: ['id'],
  },
  InvoiceNode: {
    merge: true,
    keyFields: ['id'],
  },
}

export default typePolicies
